import { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import {
  listReservationAvailabilities,
  resetReservationAvailability
} from 'redux/reservationAvailabilities/actions';
import { getReservationType } from 'redux/reservationTypes/actions';
import { getReservationTypeBySlug } from 'redux/reservationTypes/reducers';

import { createSearchString } from './helpers';
import AvailabilityListWidget from './list/AvailabilityListWidget';
// eslint-disable-next-line import/no-cycle
import SearchFormWidget from './search/SearchFormWidget';

const AvailabilityWidget = (props) => {
  const { form, reservationTypeSlug } = props;
  const [isSearch, setIsSearch] = useState(false);
  const [reservationDate, setReservationDate] = useState(null);
  const [guestCount, setGuestCount] = useState(null);
  const [reservationTime, setReservationTime] = useState(null);

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getReservationType(reservationTypeSlug));
  }, [dispatch, reservationTypeSlug]);

  const reservationType = useSelector((state) =>
    getReservationTypeBySlug(state.reservationType, reservationTypeSlug)
  );

  const settingsReducer = useSelector((state) => state.setting);

  const handleSearch = (data) => {
    const params = data;
    setIsSearch(true);
    setReservationDate(params.reservationDate);
    setReservationTime(params.reservationTime);
    setGuestCount(params.guestCount);
    params.reservationTypeId = reservationType.id;
    const searchString = createSearchString(params, settingsReducer);
    dispatch(resetReservationAvailability());
    dispatch(listReservationAvailabilities(searchString, 'Widget'));
  };

  if (!settingsReducer.data) {
    return null;
  }
  if (!reservationType) {
    return null;
  }
  return (
    <>
      <SearchFormWidget
        form={form}
        onSearch={handleSearch}
        reservationDate={reservationDate}
        reservationTypeSlug={reservationTypeSlug}
      />
      {isSearch && (
        <AvailabilityListWidget
          onSearch={handleSearch}
          reservationDate={reservationDate}
          guestCount={guestCount}
          reservationTime={reservationTime}
          reservationTypeId={reservationType.id}
        />
      )}
    </>
  );
};

export default AvailabilityWidget;
